import JoinGame from "./JoinGame";
import useTranslation from "next-translate/useTranslation";
import { useLobby, setTab } from "../../redux/lobby";
import {
  LIVE_GAME_TAB,
  DAILY_TAB,
  DAILY_GAMES_TAB,
  CREATE_GAME_TAB,
} from "@chesshotel/constants";
import CLobbyMain from "./daily/CLobbyMain";
import CActive from "./daily/CActive";
import { useDaily } from "../../redux/daily";
import { UserDailyGame } from "@chesshotel/types";
import { useEffect, useRef } from "react";
import CreateGame from "./CreateGame";
import Tabs from "./Tabs";
import PlayersOnline from "./PlayersOnline";
import { useWsConnection } from "@/redux/wsConnection";

export default function LobbyBody({ isDesktop }) {
  const { t } = useTranslation("common");

  const { invites, tab } = useLobby();
  const { games } = useDaily();
  const { wsConnected } = useWsConnection();
  // const prevIsDesktop = useRef(isDesktop);

  const gameArr = Object.values(games);
  let myTurnGames = 0;

  const nrInvites = invites.length;

  gameArr.forEach((game: any) => {
    if (game.turn && game.resultId == null) {
      myTurnGames++;
    }
  });
  const onGoingGames = gameArr.filter(
    (game: UserDailyGame) => game.resultId == null
  );

  const hasGames = onGoingGames.length != 0;

  let nrTabs = isDesktop ? 2 : 3;
  if (hasGames) {
    nrTabs = isDesktop ? 3 : 4;
  }

  useEffect(() => {
    // if (prevIsDesktop.current != isDesktop) {
    if (isDesktop && tab == CREATE_GAME_TAB) {
      setTab(LIVE_GAME_TAB);
    }
    // }
    // prevIsDesktop.current = isDesktop;
  }, [isDesktop]);

  useEffect(() => {
    if (!hasGames && tab == DAILY_GAMES_TAB) {
      setTab(DAILY_TAB);
    }
  }, [hasGames]);

  function renderSelectedTab() {
    if (tab === CREATE_GAME_TAB) {
      return <CreateGame isDesktop={isDesktop} />;
    } else if (tab === LIVE_GAME_TAB) {
      return <JoinGame />;
    } else if (tab === DAILY_TAB) {
      return <CLobbyMain />;
    } else if (tab === DAILY_GAMES_TAB) {
      return <CActive />;
    }
  }

  function handleCreate() {
    setTab(CREATE_GAME_TAB);
  }

  function handleLive() {
    setTab(LIVE_GAME_TAB);
  }

  function handleDaily() {
    setTab(DAILY_TAB);
  }

  function handleGames() {
    setTab(DAILY_GAMES_TAB);
  }

  return (
    <div className="flex justify-center w-full border border-b-[3px] rounded-b-md rounded-t-xl bg-white h-[518px] md:h-[488px]">
      <div className="flex relative flex-col items-center w-full">
        <Tabs nrTabs={nrTabs}>
          {!isDesktop && (
            <Tabs.Tab
              mobile
              selected={tab === CREATE_GAME_TAB}
              nrTabs={nrTabs}
              onClick={handleCreate}
            >
              {t("Create")}
            </Tabs.Tab>
          )}

          <Tabs.Tab
            selected={tab === LIVE_GAME_TAB}
            nrTabs={nrTabs}
            onClick={handleLive}
          >
            {t("Live")}
            {nrInvites > 0 && tab !== LIVE_GAME_TAB && (
              <div className="flex absolute top-0 right-0 bottom-0 justify-center items-center my-auto w-5 h-5 text-white rounded-lg -translate-x-1/2 md:hidden bg-altblue-300 md:w-6 md:h-6">
                {nrInvites}
              </div>
            )}
          </Tabs.Tab>
          <Tabs.Tab
            selected={tab === DAILY_TAB}
            nrTabs={nrTabs}
            onClick={handleDaily}
          >
            {t("Daily")}
          </Tabs.Tab>
          {hasGames && (
            <Tabs.Tab
              selected={tab === DAILY_GAMES_TAB}
              nrTabs={nrTabs}
              onClick={handleGames}
            >
              {t("Games")}
              {myTurnGames > 0 && tab !== DAILY_GAMES_TAB && (
                <div className="flex absolute top-0 right-0 bottom-0 justify-center items-center my-auto w-5 h-5 text-white bg-red-300 bg-opacity-80 rounded-lg -translate-x-1/2 md:w-6 md:h-6">
                  {myTurnGames}
                </div>
              )}
            </Tabs.Tab>
          )}
        </Tabs>
        {wsConnected ? (
          renderSelectedTab()
        ) : (
          <div className="flex justify-center items-center h-full">
            <span className="loader"></span>
          </div>
        )}
        <div className="flex absolute bottom-0 z-10 pb-4 w-full bg-white md:hidden">
          {wsConnected && <PlayersOnline />}
        </div>
      </div>
    </div>
  );
}
